import React from 'react';
import { Switch as HeadlessUiSwitch } from '@headlessui/react';

import ProductTypeFilter from '../../../filterFactory/ProductTypeFilter';
import { useTreatmentFilterStateContext, useTreatmentFilterUpdaterContext } from '../../context/TreatmentFilterContext';

import Typography from '../../../../../_ui/_blocks/Typography/Typography';
import Switch from '../../../../../_ui/_blocks/Form/Inputs/Switch/Switch';

import styles from './OverTheCounterFilter.module.css';

const FILTER_KEY = 'productType';

const OverTheCounterFilter = () => {
    const { filters } = useTreatmentFilterStateContext();
    const { updateFilters, setLastFilterUpdated } = useTreatmentFilterUpdaterContext();

    const productTypeFilter = filters.get(FILTER_KEY) as ProductTypeFilter;

    const checked = productTypeFilter.keys.has(true);

    const handleChange = () => {
        if (checked) {
            productTypeFilter.keys.delete(true);
        } else {
            productTypeFilter.keys.add(true);
        }
        updateFilters();
        setLastFilterUpdated(FILTER_KEY);
    };

    return (
        <HeadlessUiSwitch.Group as="section" className="flex items-center justify-between gap-100">
            <div className="space-y-025">
                <HeadlessUiSwitch.Label as="h4">
                    <Typography typeset="subheading">
                        Show only over-the-counter treatments
                    </Typography>
                </HeadlessUiSwitch.Label>
                <Typography typeset="subheading" size="080" color="quiet" className="inline-block" lineHeight="300">
                    Enable to show only treatments that can be purchased <span className="inline-block">over-the-counter</span>
                </Typography>
            </div>
            <HeadlessUiSwitch onChange={handleChange} className={styles.switchWrapper} checked={checked}>
                <Switch className="flex-shrink-0" checked={checked} />
            </HeadlessUiSwitch>
        </HeadlessUiSwitch.Group>
    );
};

export default OverTheCounterFilter;
